import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import React from "react";
import Styled from "styled-components"; // Colors

import { extended, primary } from "@uprise/colors";
var Heading3 = Styled.h3(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      font-family: ", "; ;\n      font-size: 24px;\n      font-weight: 600;\n      font-style: normal;\n      font-stretch: normal;\n      line-height: 1.25;\n      letter-spacing: normal;\n      width: ", ";\n      text-align: ", ";\n      color: ", ";\n"])), function (props) {
  return props.weight === "bold" ? "Proxima Nova Semibold" : "Proxima Nova";
}, function (props) {
  return props.width;
}, function (props) {
  return props.textAlign;
}, function (props) {
  return props.color;
});
export var H3 = function H3(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Heading3, props, children);
}; // array, bool, func, number, object, string
// symbol, node, element, elementType
// instanceOf oneOf oneOfType shape, exact, func, any

H3.defaultProps = {
  className: "",
  color: primary.charcoal,
  width: "",
  textAlign: "",
  weight: "bold"
};